module.exports = __webpack_public_path__ + "static/media/a-fall-dinner.eff8da66.jpg";